import shadows, { Shadows } from "@mui/material/styles/shadows"
import { createTheme } from "@mui/material"
import Theme from "./Theme"

export function createMuiTheme(theme: Theme) {
  return createTheme({
    components: {
      MuiButton: {
        defaultProps: {
          variant: "contained",
        },
        styleOverrides: {
          root: {
            borderRadius: 6,
            textTransform: "unset",
            fontSize: "1rem",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
            color: "#30aade",
            ":visited": {
              color: "#30aade",
            },
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            filter: "drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25))",
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            textTransform: "unset",
            fontSize: "0.9rem",
            padding: "5px 15px",
          },
        },
      },
      MuiTooltip: {
        defaultProps: {
          enterTouchDelay: 0,
        },
      },
    },
    typography: {
      fontFamily: "'Montserrat', sans-serif",
      h1: {
        fontSize: "1.8rem",
        fontWeight: 600,
      },
      h2: {
        fontSize: "1.5rem",
        fontWeight: 500,
      },
      h3: {
        fontSize: "1.3rem",
        fontWeight: 400,
      },
      subtitle1: {
        fontSize: "1rem",
        fontWeight: 500,
      },
      subtitle2: {
        fontSize: "0.8rem",
        fontWeight: 500,
      },
      caption: {
        lineHeight: 1.33,
      },
    },
    palette: {
      primary: {
        main: "#30aade",
        contrastText: "#FFF",
      },
      secondary: {
        main: "#555",
        contrastText: "#FFF",
      },
    },
    shadows: shadows.map(() => "none") as Shadows,
  })
}
